import {
  Module,
  VideoActivityData,
  MCQActivityData,
  EnglishSentenceData,
  FillInTheBlankData,
  ListeningData,
  BuildSentenceData,
  MatchData,
  CelebrateData,
} from "../activityTypes";
import {
  M3_REVIEW_1_LESSON_ID,
  M3_REVIEW_2_LESSON_ID,
  M3_REVIEW_3_LESSON_ID,
} from "../flightSchoolContent";
import {
  CION_WORDS,
  ANTE_WORDS,
  DAD_WORDS,
  MENTE_WORDS,
  ALL_COGNATE_WORDS,
} from "./words";

// =============================================================================
// Module 3 Activities (Cognates Review — v4 format)
// 18 steps: Mixed review of all 4 patterns
// =============================================================================

// --- Section 1 (Steps 1-6) ---

const m3Step1_ES: EnglishSentenceData = {
  id: "m3-step1",
  type: "english_sentence",
  sentence:
    "You can learn a lot of really useful {información} at {universidad}.",
  cognateWords: [CION_WORDS[1], DAD_WORDS[2]], // información, universidad
};

const m3Step2_MCQ: MCQActivityData = {
  id: "m3-step2-mcq",
  type: "mcq",
  question: "community",
  options: [
    { choice: "comunidad", correct: true },
    { choice: "universidad", correct: false },
    { choice: "realidad", correct: false },
    { choice: "oportunidad", correct: false },
  ],
  isReverse: true,
};

const m3Step3_Video: VideoActivityData = {
  id: "m3-step3-video",
  type: "video",
  lessonId: M3_REVIEW_1_LESSON_ID,
};

const m3Step4_Listen: ListeningData = {
  id: "m3-step4-listen",
  type: "listening",
  targetWord: CION_WORDS[5], // aplicación
  distractorWord: CION_WORDS[0], // comunicación
  additionalDistractors: [CION_WORDS[2], CION_WORDS[4]], // situación, educación
};

const m3Step5_Fill: FillInTheBlankData = {
  id: "m3-step5-fill",
  type: "fill_in_the_blank",
  spanishSentence: "La ___ es muy importante",
  englishHint: "The community is very important.",
  correctWord: DAD_WORDS[4], // comunidad
  incorrectWord: DAD_WORDS[0], // realidad
  extraIncorrectWords: [DAD_WORDS[2], DAD_WORDS[5]], // universidad, oportunidad
  showWordHints: true,
  wordHints: { muy: "very" },
};

const m3Step6_Celebrate: CelebrateData = {
  id: "m3-step6-celebrate",
  type: "celebrate",
  patternLabel: "-CIÓN = -TION",
  words: [
    CION_WORDS[1], // información
    DAD_WORDS[2], // universidad
    DAD_WORDS[4], // comunidad
    CION_WORDS[5], // aplicación
  ],
};

// --- Section 2 (Steps 7-12) ---

const m3Step7_ES: EnglishSentenceData = {
  id: "m3-step7",
  type: "english_sentence",
  sentence:
    "The {situación} at the {restaurante} got real {interesante} when my ex walked in.",
  cognateWords: [CION_WORDS[2], ANTE_WORDS[1], ANTE_WORDS[3]], // situación, restaurante, interesante
};

const m3Step8_Build: BuildSentenceData = {
  id: "m3-step8-build",
  type: "build_sentence",
  correctSentence: "La comunicación es importante",
  englishHint: "Communication is important",
  words: ["importante", "comunicación", "es", "La"],
  cognateWord: CION_WORDS[0], // comunicación
  showEnglishHints: true,
};

const m3Step9_Video: VideoActivityData = {
  id: "m3-step9-video",
  type: "video",
  lessonId: M3_REVIEW_2_LESSON_ID,
};

const m3Step10_Listen: ListeningData = {
  id: "m3-step10-listen",
  type: "listening",
  targetWord: MENTE_WORDS[2], // rápidamente
  distractorWord: MENTE_WORDS[0], // normalmente
  additionalDistractors: [MENTE_WORDS[1], MENTE_WORDS[4]], // exactamente, finalmente
};

const m3Step11_Match: MatchData = {
  id: "m3-step11-match",
  type: "match",
  pairs: [
    CION_WORDS[0], // comunicación
    ANTE_WORDS[2], // elegante
    CION_WORDS[4], // educación
    CION_WORDS[3], // nación
    DAD_WORDS[3], // posibilidad
  ],
};

const m3Step12_Celebrate: CelebrateData = {
  id: "m3-step12-celebrate",
  type: "celebrate",
  patternLabel: "-ANTE = -ANT",
  words: [
    CION_WORDS[0], // comunicación
    CION_WORDS[2], // situación
    ANTE_WORDS[1], // restaurante
    ANTE_WORDS[3], // interesante
    ANTE_WORDS[2], // elegante
    CION_WORDS[4], // educación
    CION_WORDS[3], // nación
    DAD_WORDS[3], // posibilidad
    MENTE_WORDS[2], // rápidamente
  ],
};

// --- Section 3: Final Review (Steps 13-18) ---

const m3Step13_ES: EnglishSentenceData = {
  id: "m3-step13",
  type: "english_sentence",
  sentence:
    "I {rápidamente} scrolled past the {importante} {información} and now I {completamente} regret it.",
  cognateWords: [MENTE_WORDS[2], ANTE_WORDS[0], CION_WORDS[1], MENTE_WORDS[3]], // rápidamente, importante, información, completamente
};

const m3Step14_MCQ: MCQActivityData = {
  id: "m3-step14-mcq",
  type: "mcq",
  question: "exactly",
  options: [
    { choice: "normalmente", correct: false },
    { choice: "exactamente", correct: true },
    { choice: "completamente", correct: false },
    { choice: "finalmente", correct: false },
  ],
  isReverse: true,
};

const m3Step15_Video: VideoActivityData = {
  id: "m3-step15-video",
  type: "video",
  lessonId: M3_REVIEW_3_LESSON_ID,
};

const m3Step16_Build: BuildSentenceData = {
  id: "m3-step16-build",
  type: "build_sentence",
  correctSentence: "La universidad tiene una oportunidad",
  englishHint: "The university has an opportunity",
  words: ["oportunidad", "tiene", "La", "una", "universidad"],
  cognateWord: DAD_WORDS[2], // universidad
  showEnglishHints: true,
  wordHints: { tiene: "has", una: "an" },
};

const m3Step17_Match: MatchData = {
  id: "m3-step17-match",
  type: "match",
  pairs: [
    CION_WORDS[5], // aplicación
    ANTE_WORDS[4], // constante
    DAD_WORDS[1], // actividad
    MENTE_WORDS[4], // finalmente
    ANTE_WORDS[1], // restaurante
  ],
};

const m3Step18_Celebrate: CelebrateData = {
  id: "m3-step18-celebrate",
  type: "celebrate",
  title: "Chapter Complete!",
  isFinal: true,
  words: ALL_COGNATE_WORDS,
  patternLabels: ["-CIÓN = -TION", "-ANTE = -ANT", "-DAD = -TY", "-MENTE = -LY"],
  totalWordsUnlocked: "1000+",
};

// =============================================================================
// Module 3 Definition - Review All Patterns
// =============================================================================

export const MODULE_3: Module = {
  id: "module-3",
  name: "Cognates Review: Master All Patterns",
  patterns: ["CION", "ANTE", "DAD", "MENTE"],
  activities: [
    // Section 1 (Steps 1-6)
    m3Step1_ES,
    m3Step2_MCQ,
    m3Step3_Video,
    m3Step4_Listen,
    m3Step5_Fill,
    m3Step6_Celebrate,
    // Section 2 (Steps 7-12)
    m3Step7_ES,
    m3Step8_Build,
    m3Step9_Video,
    m3Step10_Listen,
    m3Step11_Match,
    m3Step12_Celebrate,
    // Section 3: Final Review (Steps 13-18)
    m3Step13_ES,
    m3Step14_MCQ,
    m3Step15_Video,
    m3Step16_Build,
    m3Step17_Match,
    m3Step18_Celebrate,
  ],
};
